import { NgModule } from '@angular/core';
import { DocumentPanelRootComponent } from './document-panel-root.component';
import { DocumentPanelRootService } from './document-panel-root.service';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: [DocumentPanelRootComponent],
    exports: [DocumentPanelRootComponent],
    providers: [DocumentPanelRootService],
})
export class FiDocumentPanelRootModule {}
